import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "app-own-user-modal",
    templateUrl: "./optimistic-locking-modal.component.html",
    styleUrls: ["./optimistic-locking-modal.component.scss"],
    standalone: false
})
export class OptimisticLockingModalComponent {
  constructor(public modal: NgbActiveModal) {}
}
